import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { FlashService } from './flash.service';

@Injectable({
  providedIn: 'root'
})
export class GridService {

    constructor(private http: HttpClient, private flashService: FlashService) { }

    GetGrid(id) {
        return this.http.get('/api/ListGrid/Grid?id=' + id).toPromise().then(this.handleSuccess, this.handleError.bind(this));
    }

    GetSection(data) {
        return this.http.post('/api/ListGrid/Section', data).toPromise().then(this.handleSuccess, this.handleError.bind(this));
    }

    GetProfilePage(id) {
        return this.http.get('/api/ListGrid/PageProfile/?id=' + id).toPromise().then(this.handleSuccess, this.handleError.bind(this));
    }

    GetProfileMenu(data) {
        return this.http.post('/api/ListGrid/PageProfileItems', data).toPromise().then(this.handleSuccess, this.handleError.bind(this));
    }

    GetProfileData(data) {
        return this.http.post('/api/ListGrid/PageProfileContent', data).toPromise().then(this.handleSuccess, this.handleError.bind(this));
    }

    GetDailySpeciesInRoomDialogInfo(data) {
        return this.http.post('/api/ListGrid/GetDailySpeciesInRoomDialogInfo', data).toPromise().then(this.handleSuccess, this.handleError.bind(this));
    }

    ChangeDailySpeciesInRoom(data) {
        return this.http.post('/api/ListGrid/ChangeDailySpeciesInRoom', data).toPromise().then(this.handleSuccess, this.handleError.bind(this));
    }

    GetAddNewPage(id) {
        return this.http.get('/api/ListGrid/PageProfileInfoTab/?id=' + id).toPromise().then(this.handleSuccess, this.handleError.bind(this));
    }

    Save(data) {
        return this.http.post('/api/ListGrid/save', data).toPromise().then(this.handleSuccess, this.handleError.bind(this));
    }

    SavePreferences(preferences) {
        return this.http.post('/api/Home/Grid/Save', preferences).toPromise().then(this.handleSuccess, this.handleError.bind(this));
    }

    UpdateSequences(data) {
        return this.http.post('/api/ListGrid/UpdateSequences', data).toPromise().then(this.handleSuccess, this.handleError.bind(this));
    }

    private handleSuccess(res) {
        return { success: true, data: res };
    }

    private handleError(res) {
        this.flashService.Error(res.error.errors.toString(), false);
        return { success: false };
    }
}
